import React from "react";
import "./style.scss";

export interface Step {
  label: string;
}

interface StepProgressBarProps {
  steps: Step[];
  currentStepIndex: number;
  percentage?: string;
}

const StepProgressBar: React.FC<StepProgressBarProps> = ({
  steps,
  currentStepIndex,
  percentage,
}) => {
  const activeIndex = Math.max(0, currentStepIndex - 1);
  const safeSteps = Array.isArray(steps) ? steps : [];

  return (
    <div
      className="step-progress"
      role="progressbar"
      aria-valuenow={currentStepIndex}
      aria-valuemin={1}
      aria-valuemax={safeSteps.length}
    >
      <div className="step-progress__track">
        {/* Full-width line behind circles so it always connects; circles sit on top */}
        <span className="step-progress__line-bg" aria-hidden />
        {safeSteps.map((step, index) => {
          const isCompleted = index < activeIndex;
          const isActive = index === activeIndex;
          const isLast = index === safeSteps.length - 1;
          const label = typeof step?.label === "string" ? step.label : "";

          return (
            <React.Fragment key={`step-${index}`}>
              <div
                className={`step-progress__step ${
                  index === 0 ? "step-progress__step--first" : ""
                } ${index === safeSteps.length - 1 ? "step-progress__step--last" : ""}`}
              >
                <div className="step-progress__node">
                  <div
                    className={`step-progress__circle ${
                      isCompleted ? "step-progress__circle--completed" : ""
                    } ${isActive ? "step-progress__circle--active" : ""}`}
                  >
                    {isCompleted ? (
                      <span className="step-progress__check" aria-hidden />
                    ) : (
                      <span className="step-progress__dot" aria-hidden />
                    )}
                  </div>
                  <span
                    className={`step-progress__label ${
                      isActive ? "step-progress__label--active" : ""
                    }`}
                    title={label}
                  >
                    {label}
                  </span>
                </div>
              </div>
              {!isLast && (
                <div
                  className={`step-progress__connector ${
                    isCompleted ? "step-progress__connector--completed" : ""
                  }`}
                  style={
                    percentage && index === activeIndex
                      ? { ["--connector-fill" as string]: `${percentage}%` }
                      : undefined
                  }
                >
                  <span className="step-progress__line" aria-hidden />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepProgressBar;
